import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './features/store';
import Home from './pages/Home/Home';
import Game from './pages/Game/Game';

const App = () => {
    return (
      <Provider store={store}>
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/game/:qSetKey/:questionTitle" element={<Game />} />
            </Routes>
        </Router>
      </Provider>
    );
};

export default App;
